  export class apiUrl {


    // region login
    public static get Login(): string { return "Login"; }
    public static get CheckToken(): string { return "Login/CheckToken"; }
    public static get GetStaffsLeaveCalender(): string { return "Reports/GetStaffsLeaveCalender"; }


    public static get GetKitchenOrders(): string { return "Dashboard/GetKitchenOrders"; }  //options
    public static get GetPlacedKitchenOrders(): string { return "Dashboard/GetPlacedKitchenOrders"; }  //options
    public static get GetdlKitchenStatus(): string { return "Dashboard/GetdlKitchenStatus"; }  //options
    public static get UpdateKitchenOrder(): string { return "Dashboard/UpdateKitchenOrder"; }  //options
    public static get GetdlKitchenShelves(): string { return "Dashboard/GetdlKitchenShelves"; }  //options



    // end
    // region dashboard
    public static get DashboardDBasicData(): string { return "Reports/GetBasicData"; }
    public static get GetStaffBasicData(): string { return "Reports/GetStaffBasicData"; }


    public static get GetDashboardWarnings(): string { return "CustomNotifications/GetDashboardWarnings"; }


    public static get GetStaffLeavesPayments(): string { return "StaffLeaves/GetStaffLeavesPayments/"; }



    public static get GetUserDetails(): string { return "Users/GetUserDetails"; }
    
    // end


    public static get GetToolWarnings(): string { return "Tools/GetToolWarnings"; }
    public static get GetVehicleWarnings(): string { return "Vehicles/GetVehicleWarnings"; }



    // region locations
    public static get LocationsGetAllForDropwDown(): string { return "Locations/GetdlLocations"; }  //options
    public static get LocationsGetAll(): string { return "Locations"; }   //options
    public static get LocationsGetById(): string { return "Locations"; }   //options
    public static get LocationsSave(): string { return "Locations"; }   //post
    public static get LocationsUpdate(): string { return "Locations"; }       //put
    public static get LocationsDisable(): string { return "Locations/DisableLocation"; } //put
    public static get LocationsDelete(): string { return "Locations"; }   //delete
    // end


    // region tools
    public static get ToolsGetAllForDropwDown(): string { return "Tools/GetdlTools"; }  //options
    public static get ToolsGetAll(): string { return "Tools"; }   //options
    public static get ToolsGetById(): string { return "Tools"; }   //options
    public static get ToolsSave(): string { return "Tools"; }   //post
    public static get ToolsUpdate(): string { return "Tools"; }       //put
    public static get ToolsDisable(): string { return "Tools/DisableTool"; } //put
    public static get ToolsDelete(): string { return "Tools"; }   //delete
    // end

    // region users
    public static get UsersGetAllForDropwDown(): string { return "Users/GetdlUsers"; }  //options
    public static get UsersGetAll(): string { return "Users"; }   //options
    public static get UsersGetById(): string { return "Users"; }   //options
    public static get UsersSave(): string { return "Users"; }   //post
    public static get UsersUpdate(): string { return "Users"; }       //put
    public static get UsersDisable(): string { return "Users/DisableUser"; } //put
    public static get UsersDelete(): string { return "Users"; }   //delete
    // end



    // region staff ticket logs
    public static get StaffTicketLogsGetAllForDropwDown(): string { return "StaffTicketLogs/GetdlStaffTicketLogs"; }  //options
    public static get StaffTicketLogsGetAll(): string { return "StaffTicketLogs"; }   //options
    public static get StaffTicketLogsGetById(): string { return "StaffTicketLogs"; }   //options
    public static get StaffTicketLogsSave(): string { return "StaffTicketLogs"; }   //post
    public static get StaffTicketLogsUpdate(): string { return "StaffTicketLogs"; }       //put
    public static get StaffTicketLogsDisable(): string { return "StaffTicketLogs/DisableStaffTicketLogs"; } //put
    public static get StaffTicketLogsDelete(): string { return "StaffTicketLogs"; }   //delete
    
    
    // region staff advances
    public static get StaffAdvancesGetAllForDropwDown(): string { return "StaffAdvances/GetdlStaffAdvances"; }  //options
    public static get StaffAdvancesGetAll(): string { return "StaffAdvances"; }   //options
    public static get StaffAdvancesGetById(): string { return "StaffAdvances"; }   //options
    public static get StaffAdvancesSave(): string { return "StaffAdvances"; }   //post
    public static get StaffAdvancesUpdate(): string { return "StaffAdvances"; }       //put
    public static get StaffAdvancesDisable(): string { return "StaffAdvances/DisableStaffAdvances"; } //put
    public static get StaffAdvancesDelete(): string { return "StaffAdvances"; }   //delete



    // region staff advances
    public static get OverTimePaymentsGetAllForDropwDown(): string { return "OverTimePayments/GetdlOverTimePayments"; }  //options
    public static get OverTimePaymentsGetAll(): string { return "OverTimePayments"; }   //options
    public static get OverTimePaymentsGetById(): string { return "OverTimePayments"; }   //options
    public static get OverTimePaymentsSave(): string { return "OverTimePayments"; }   //post
    public static get OverTimePaymentsUpdate(): string { return "OverTimePayments"; }       //put
    public static get OverTimePaymentsDisable(): string { return "OverTimePayments/DisableOverTimePayments"; } //put
    public static get OverTimePaymentsDelete(): string { return "OverTimePayments"; }   //delete


    // region staff holidays
    public static get HolidaysGetAllForDropwDown(): string { return "Holidays/GetdlHolidays"; }  //options
    public static get HolidaysGetAll(): string { return "Holidays"; }   //options
    public static get HolidaysGetById(): string { return "Holidays"; }   //options
    public static get HolidaysSave(): string { return "Holidays"; }   //post
    public static get HolidaysUpdate(): string { return "Holidays"; }       //put
    public static get HolidaysDisable(): string { return "Holidays/DisableHolidays"; } //put
    public static get HolidaysDelete(): string { return "Holidays"; }   //delete

    public static get AddStaffEOS(): string { return "Staffs/GetStaffEOSDetails"; }   //post
    public static get GetStaffEOSDetailsbyId(): string { return "Staffs/GetStaffEOSDetailsbyId"; }   //options

    public static get GetConsolidateStaffAdvance(): string { return "StaffAdvances/GetConsolidateStaffAdvance"; }   //options


    // end


     // region staffs
     public static get StaffsGetAllForDropwDown(): string { return "Staffs/GetdlStaffs"; }  //options
     public static get StaffsGetAll(): string { return "Staffs"; }   //options
     public static get StaffsGetById(): string { return "Staffs"; }   //options
     public static get StaffsSave(): string { return "Staffs"; }   //post
     public static get StaffsUpdate(): string { return "Staffs"; }       //put
     public static get StaffsDisable(): string { return "Staffs/DisableStaff"; } //put
     public static get StaffsDelete(): string { return "Staffs"; }   //delete
     // end

     public static get GetdlDesignations(): string { return "Staffs/GetdlDesignations"; }  //options




      // region clients
    public static get ClientsGetAllForDropwDown(): string { return "Clients/GetdlClients"; }  //options
    public static get ClientsGetAll(): string { return "Clients"; }   //options
    public static get ClientsGetById(): string { return "Clients"; }   //options
    public static get ClientsSave(): string { return "Clients"; }   //post
    public static get ClientsUpdate(): string { return "Clients"; }       //put
    public static get ClientsDisable(): string { return "Clients/DisableClient"; } //put
    public static get ClientsDelete(): string { return "Clients"; }   //delete
    // end



     // region jobs
     public static get JobsGetAllForDropwDown(): string { return "Jobs/GetdlJobs"; }  //options
     public static get JobsGetAll(): string { return "Jobs"; }   //options
     public static get JobsGetAllByFilter(): string { return "Jobs/GetJobs"; }   //post
     public static get GetStaffJobs(): string { return "Jobs/GetStaffJobs"; }   //post
     public static get GetUnAttendedJobs(): string { return "Jobs/GetUnAttendedJobs"; }   //post

     public static get GetStaffJobsDashboard(): string { return "Jobs/GetStaffJobsDashboard"; }   //post


     public static get JobsGetById(): string { return "Jobs"; }   //options
     public static get JobsSave(): string { return "Jobs"; }   //post
     public static get JobsUpdate(): string { return "Jobs"; }       //put
     public static get JobsDisable(): string { return "Jobs/DisableJob"; } //put
     public static get JobsDelete(): string { return "Jobs"; }   //delete



     public static get SaveStaffsForJob(): string { return "JobStaffMappings"; }   //post
     public static get GetStaffsForJob(): string { return "JobStaffMappings/GetJobStaffList/"; }   //options


     public static get SaveStaffsForTeam(): string { return "Teams/TeamStaffMapping"; }   //post
     public static get GetStaggForTeam(): string { return "Teams/GetTeamStaffs/"; }   //options

     // end



      // region vehicles
    public static get VehiclesGetAllForDropwDown(): string { return "Vehicles/GetdlVehicles"; }  //options
    public static get VehiclesGetAll(): string { return "Vehicles"; }   //options
    public static get VehiclesGetById(): string { return "Vehicles"; }   //options
    public static get VehiclesSave(): string { return "Vehicles"; }   //post
    public static get VehiclesUpdate(): string { return "Vehicles"; }       //put
    public static get VehiclesDisable(): string { return "Vehicles/DisableVehicle"; } //put
    public static get VehiclesDelete(): string { return "Vehicles"; }   //delete
    // end
      // region teams
    public static get TeamsGetAllForDropwDown(): string { return "Teams/GetdlTeams"; }  //options
    public static get TeamsGetAll(): string { return "Teams"; }   //options
    public static get TeamsGetById(): string { return "Teams"; }   //options
    public static get TeamsSave(): string { return "Teams"; }   //post
    public static get TeamsUpdate(): string { return "Teams"; }       //put
    public static get TeamsDisable(): string { return "Teams/DisableTeam"; } //put
    public static get TeamsDelete(): string { return "Teams"; }   //delete
    // end


    
    

    public static get GetStaffLogsForApproval(): string { return "Staffs/GetStaffLogsForApproval"; }   //options
    public static get GetStaffLogsForUpdate(): string { return "Staffs/GetStaffLogsForUpdate"; }   //options

    public static get ApproveStaffLogs(): string { return "Staffs/ApproveStaffLogs"; }   //options
    public static get UpdateStaffLog(): string { return "Staffs/UpdateStaffLog"; }   //options
   


    public static get UpdateToolLog(): string { return "Tools/PutToolLog"; }   //options
    public static get UpdateVehicleLog(): string { return "Vehicles/PutVehicleLog"; }   //options


    public static get GetUnApporvedStaffLeaves(): string { return "StaffLeaves/GetUnApporvedStaffLeaves/"; }   //options
    public static get GetUnPaidStaffLeaves(): string { return "StaffLeaves/GetUnPaidStaffLeaves"; }   //options
    public static get ApproveLeave(): string { return "StaffLeaves/ApproveLeave/"; }   //options
    public static get ApproveMultipleLeaves(): string { return "StaffLeaves/ApproveMultipleLeaves"; }   //options


    public static get MarkPaidOverTimePayments(): string { return "OverTimePayments/MarkPaidOverTimePayments"; }   //options

    public static get GetStaffDetailsbyStaffId(): string { return "OverTimePayments/GetStaffDetailsbyStaffId"; }   //options

    public static get LeaveEdit(): string { return "StaffLeaves"; }   //options



    public static get GetStaffJobsReport(): string { return "Reports/GetStaffJobs"; }   //options
    public static get GetTeamJobsReport(): string { return "Reports/GetTeamJobs"; }   //options
    public static get GetVehicleJobsReport(): string { return "Reports/GetVehicleJobs"; }   //options
    public static get GetToolJobsReport(): string { return "Reports/GetToolJobs"; }   //options

    public static get GetJobsbyStatus(): string { return "Jobs/GetJobsbyStatus"; }   //options

    public static get UpdateJobStatus(): string { return "Jobs/UpdateJobStatus/"; }   //options




    public static get GetTop1ToolsAssignedJob(): string { return "Reports/GetTop1ToolsAssignedJob"; }   //options
    public static get GetTop1VehiclesAssignedJob(): string { return "Reports/GetTop1VehiclesAssignedJob"; }   //options
    public static get GetTop1StaffsAssignedJob(): string { return "Reports/GetTop1StaffsAssignedJob"; }   //options
    public static get GetApporvedStaffLeaves(): string { return "StaffLeaves/GetApporvedStaffLeaves/"; }   //options
    public static get GetStaffWorkLogReport(): string { return "Reports/GetStaffWorkLogReport"; }   //options




    public static get GetStaffOverTimeNAdvance(): string { return "OverTimePayments/GetStaffOverTimeNAdvance"; }   //options



    public static get GetStaffLeaveReportHR(): string { return "Reports/GetStaffLeaveReportHR"; }   //options
    public static get GetStaffEOSReport(): string { return "Reports/GetStaffEOSReport"; }   //options
    public static get GetStaffWorkLogConsolidateReport(): string { return "Reports/GetStaffWorkLogConsolidateReport"; }   //options

    public static get GetStaffAdvanceReport(): string { return "Reports/GetStaffAdvanceReport"; }   //options
    public static get GetOverTimePayments(): string { return "Reports/GetOverTimePayments"; }   //options
    public static get GetStaffTicketReport(): string { return "Reports/GetStaffTicketReport"; }   //options
    public static get GetStaffTicketEligibility(): string { return "Reports/GetStaffTicketEligibility"; }   //options

    public static get GetLeavesCalculation(): string { return "StaffLeaves/GetLeavesCalculation/"; }   //options
    public static get GetStaffEligibleData(): string { return "StaffLeaves/GetStaffEligibleData"; }   //options
    public static get SaveLeavePayment(): string { return "StaffLeaves/SaveLeavePayment"; }   //options



    public static get GetStaffLeavePaymentReport(): string { return "Reports/GetStaffLeavePaymentReport"; }   //options



    public static get GetLeavesCalculationPreview(): string { return "StaffLeaves/GetLeavesCalculationPreview/"; }   //options


    public static get GetStaffDetailbyId(): string { return "Staffs/GetStaffDetailbyId"; }   //options
    public static get GetApprovedAnnualLeavesbyStaffId(): string { return "StaffLeaves/GetApprovedAnnualLeavesbyStaffId"; }   //options
    public static get GetAdvancebyStaffId(): string { return "StaffAdvances/GetAdvancebyStaffId"; }   //options
    public static get GetStaffTicketbyStaffId(): string { return "StaffTicketLogs/GetStaffTicketbyStaffId"; }   //options
    public static get GetOverTimePaymentsbyStaffId(): string { return "OverTimePayments/GetOverTimePaymentsbyStaffId"; }   //options
    
    public static get GetUnPaidOverTimePaymentsbyStaffId(): string { return "OverTimePayments/GetUnPaidOverTimePaymentsbyStaffId"; }   //options
   

  }
